import PhotoSwipeGallery from "./PhotoSwipeGallery";

/**
 * Builds a slide show on top of PhotoSwipe.
 */
export default class SlideShow {

    /**
     *
     * @param photoSwipeGallery PhotoSwipeGallery
     */
    constructor(photoSwipeGallery) {
        this._photoSwipeGallery = photoSwipeGallery;
        this._SlideShow_Running = false;
        this._currentTimer = null;
        this._SlideShow_Delay = 2000 /*ms*/;
        this._SlideShow_Button = document.getElementsByClassName('pswp__button--playpause')[0];

        let interactionHandler = (e) => {
            e.preventDefault();
            e.stopPropagation();
            return this.toggleSlideShowState();
        };

        // take care about both click and touch.
        this._SlideShow_Button.onclick = interactionHandler;
        this._SlideShow_Button.ontouchstart = interactionHandler;

        this._photoSwipeGallery.listen('afterChange', () => {
            this._planNextSwitch(false);
        });

        this._photoSwipeGallery.listen('destroy', () => this._photoSwipeGallery=null);

        this._photoSwipeGallery.listen('userInteractionHappened', () => this._stopSlideshow());
        this._photoSwipeGallery.listen('mainScrollAnimStart', () => this._stopSlideshow());


        this._adjustNavigation();
    }

    /**
     *
     * @param delay int
     */
    setDelay(delay) {
        this._SlideShow_Delay = delay;
    }

    /**
     * switches the slide show on/off depending on the current state
     */
    toggleSlideShowState() {

        if (this._SlideShow_Running) {
            this._stopSlideshow();
        } else {
            this._startSlideshow();
        }
    }

    _stopSlideshow() {
        this._SlideShow_Running = false;
        this._adjustNavigation();
    }

    _startSlideshow() {
        this._SlideShow_Running = true;
        this._planNextSwitch(true);
        this._adjustNavigation();
    }

    /**
     * make sure the navigation displays the current slide show state.
     */
    _adjustNavigation() {
        this._SlideShow_Button.classList.remove(this._SlideShow_Running ? "play" : "pause");
        this._SlideShow_Button.classList.add(this._SlideShow_Running ? "pause" : "play");
        this._SlideShow_Button.setAttribute('title', this._SlideShow_Running ? this._SlideShow_Button.getAttribute('data-title-pause'): this._SlideShow_Button.getAttribute('data-title-play'));
    }

    /**
     * create the timeout for the next switch.
     *
     * @param isForTheFirstSwitch Boolean changes the switch time so the first switch can be faster
     */
    _planNextSwitch(isForTheFirstSwitch)  {
        clearTimeout(this._currentTimer);
        this._currentTimer = setTimeout(() => this._nextSlide(), isForTheFirstSwitch ? this._SlideShow_Delay / 2.0 :this._SlideShow_Delay);
    }

    /**
     * change to the next slide
     */
    _nextSlide() {
        if (this._photoSwipeGallery === null) {
            return;
        }

        if (!this._SlideShow_Running) {
            return;
        }

        this._photoSwipeGallery.nextSlide();
    }
}